import { pageNames } from 'core/constants';

export const AmplitudeEvents = {
  signIn: 'SIGN_IN',
  pageVisit: 'PAGE_VISIT',
  pageNames: Object.values(pageNames),
  userRegistration: 'USER_REGISTRATION',
  toggleButtonCommodityGraph: 'TOGGLE_BUTTON_COMMODITY_GRAPH',
  clonedCampaign: 'CLONED_CAMPAIGN',
  reminderEmailSent: 'REMINDER_EMAIL_SENT',
  bankTransferDetails: 'BANK_TRANSFER_DETAILS',
  validateActuals: 'VALIDATE_ACTUALS',
  manualActualUpload: 'MANUAL_ACTUAL_UPLOAD',
  manualCommittedUpload: 'MANUAL_COMMITTED_UPLOAD',
  emailLinkClicked: 'EMAIL_LINK_CLICKED',
};
